export const CATEGORY_LABELS = {
  faith_journey: "Faith Journey",
  community: "Community",
  life_challenges: "Life & Wellbeing",
};

const SCRIPTURES = {
  low: '"For I know the plans I have for you," declares the LORD, "plans to prosper you and not to harm you, plans to give you hope and a future." (Jeremiah 29:11)',
  medium:
    '"Trust in the LORD with all your heart and lean not on your own understanding; in all your ways submit to him, and he will make your paths straight." (Proverbs 3:5-6)',
  high: '"I can do all this through him who gives me strength." (Philippians 4:13)',
};

const FOCUS_AREAS = {
  faith_journey: [
    "Set aside 10 minutes daily for prayer and reflection",
    "Start a Bible reading plan with a daily chapter",
    "Journal your spiritual thoughts and insights",
  ],
  community: [
    "Attend a small group or Bible study",
    "Reach out to a fellow church member this week",
    "Volunteer for a church ministry that interests you",
  ],
  life_challenges: [
    "Identify one area where you need God's guidance",
    "Share your struggles with a trusted friend or mentor",
    "Practice gratitude by listing 3 blessings daily",
  ],
  spiritual_practices: [
    "Establish a consistent morning devotional time",
    "Practice silence and solitude for 15 minutes weekly",
    "Memorize one scripture verse this month",
  ],
};

const DEFAULT_FOCUS_AREAS = [
  "Spend dedicated time in daily prayer",
  "Connect with your church community",
  "Reflect on God's faithfulness in your life",
];

export const OUTCOMES = [
  "Deeper sense of peace and purpose",
  "Stronger connection with your faith community",
  "Greater confidence in facing life's challenges",
  "More consistent spiritual practices",
];

/** Scripture and focus areas for a spiritual survey result, driven by the lowest category score. */
export const buildPersonalizedContent = (result) => {
  const overallScore = result?.overallScore || 3;
  const scores = result?.scores || {};

  let lowestCategory = null;
  let lowestScore = 5;
  Object.entries(scores).forEach(([category, score]) => {
    if (score < lowestScore) {
      lowestScore = score;
      lowestCategory = category;
    }
  });

  const level = overallScore < 2.5 ? "low" : overallScore < 4 ? "medium" : "high";

  return {
    scripture: SCRIPTURES[level],
    focusAreas: FOCUS_AREAS[lowestCategory] || DEFAULT_FOCUS_AREAS,
  };
};
